export default __webpack_public_path__ + "static/logo-svg-c5174702e74647c3d2fadb219bbef655.svg";